import React,{ useEffect } from "react";
import SectionText from "./SectionText";
import HeaderSection from "./HeaderSection";
import { useSector } from "./SectorContext";
import CyberPortfolioSection from "./CyberPortfolioSection";
import AltPortfolioSection from "./AltPortfolioSection";
import ContactSection from "./ContactSection";
import FooterSection from "./FooterSection";
import useReveal from "./hooks/useReveal";
import CertSection from "./CertSection";
import AwardCarousel from "./AwardCarousel";
const HomePage = () => {
  const { activeSector, selectedSector} = useSector();
  useReveal(selectedSector);

  useEffect(() => {
  document.title =
    "Valentino Lloyd | Cybersecurity, Advertising & Web Development";
}, []);

  return (
    <>
      {" "}
      <HeaderSection />
      <div className={`text-band  ${activeSector.colorClass}`}>
        <div className="text-band-inner shiny-border" data-reveal>
          {selectedSector === "advertising"? <AwardCarousel/>:<CertSection /> }
          {/* {console.log(activeSector)} */}
          
          <SectionText />
        </div>
      </div>
      <div className="app-container">
        <div className="home-page">
          {/* Renders portfolio section based on activeSector.colorClass*/}
          {activeSector.colorClass === "cyber-accent" ? (
            <CyberPortfolioSection />
          ) : (
            <AltPortfolioSection />
          )}
      

          <div className={`contact-band ${activeSector.colorClass}` }>
            <ContactSection />
          </div>

          <FooterSection />
        
        </div>
      </div>
    </>
  );
};

export default HomePage;
